import { Typography, TableCell } from '@mui/material';

const CellHeader: React.FC<{ title: string }> = ({ title }) => (
  <TableCell
    style={{ padding: '10px 16px', width: 'auto', minWidth: "150px", borderBottomColor: 'rgba(255, 255, 255, 0.4)' }}>
    <Typography variant="subtitle1" color="#FFF" fontFamily={'American Mono'}>
      {title}
    </Typography>
  </TableCell>
);

export default CellHeader;
